import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textField: {
    margin: 'auto',
    width: '100%',
  },
}));

export default function ForgotPasswordDialog(props) {
  const [username, setUsername] = useState('');

  const classes = useStyles();

  const clearForm = () => {
    setUsername('');
  };

  const handleClose = () => {
    clearForm();
    props.handleClose();
  };

  const handleSubmit = () => {
    props.handlePasswordReset(username);
    clearForm();
    handleClose();
  };

  const keyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Dialog open={props.open} onClose={handleClose} aria-labelledby='form-dialog-title' keepMounted maxWidth={false}>
      <DialogTitle>Password Reset</DialogTitle>
      <DialogContent>
        <DialogContentText>Please enter the username of your account.</DialogContentText>
        <TextField
          id={'usernameToFind'}
          label={'Username'}
          name={'Username'}
          onChange={(event) => {
            setUsername(event.target.value);
          }}
          onKeyPress={keyPress}
          value={username}
          type={'text'}
          className={classes.textField}
          margin='dense'
          variant='outlined'
          autoFocus
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color='secondary'>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color='primary'>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
